import { render, staticRenderFns } from "./revenue_projection.vue?vue&type=template&id=6708f41f&scoped=true&"
import script from "./revenue_projection.vue?vue&type=script&lang=js&"
export * from "./revenue_projection.vue?vue&type=script&lang=js&"
import style0 from "./revenue_projection.vue?vue&type=style&index=0&id=6708f41f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708f41f",
  null
  
)

export default component.exports